import {isArray, isObject} from "my-tools-kit";
// import {baseDataGroupingDeliveryTypeMapObject} from "@views/placeOrderOpenGroup/warehouseVolumeGrouping";

/**
 * 计算自定义最大最小值
 */
export function countCustomMaxPrice(price,ratio = 0){
  ratio =  ratio/100;
  let num = price * ( 1 + ratio);
  return Math.round( num * 100 ) / 100;
}
export function countCustomMinPrice(price,ratio = 0){
  ratio =  ratio/100;
  let num = price * ( 1 - ratio);
  return Math.round( num * 100 ) / 100;
}

/**
 * 赋值优惠券列表
 */
export function setCouponList( list = []){
  this.couponList = list;
  if(this.selectCouponList && this.selectCouponList.length) rejudgeAlreadySelectCoupon.call(this);
}

/**
 * 改变（预估）价格后，需要重新判断已选择的是否可用于当前价格
 * 1、试算接口新返回的待使用优惠券列表中包含已选优惠券；
 * 2、满减券是否符合当前新的试算金额
 */
export function rejudgeAlreadySelectCoupon(){
  let orderAmount = this.estimatedFeeData.totalPriceRmb||0;
  let removeCouponList = [];
  let list = this.selectCouponList.filter(item=>{
    let index = this.couponList.findIndex(res=>res.id === item.id);
    if(index < 0) {
      removeCouponList.push(item);
      return false;
    }
    if(item.couponType === "FR"){
      if(!orderAmount && orderAmount !== 0) {
        removeCouponList.push(item);
        return false;
      }
      if(!item.maxAmount) {
        removeCouponList.push(item);
        return false;
      }
      if(orderAmount < item.maxAmount) {
        removeCouponList.push(item);
        return false;
      }
    }
    return  true;
  });
  if(list.length !== this.selectCouponList.length ) this.selectCouponList = list;
  if(removeCouponList.length) console.log("重新匹配已选择优惠券列表，移除",removeCouponList);
}

/**
 * 计算使用优惠券后订单金额数据 结构
 */
export function getBaseDataCountCouponAfterFee(){
  return {
    discountAmount:0,//总优惠金额
    discountAfterAmount:0,//优惠后订单金额
  }
}
/**
 * 本地 计算使用优惠券后的金额
 */
export function localCountUseCouponAfterPrice(orderAmount = 0){
  let countRecord = "";
  let FRlist = [];//满减券列表
  let DClist = [];//折扣券列表
  let CPlist = [];//立减券列表
}

/*
优惠券类型 coupon_type:FR、DC、CP
-------------------------------------
FR 满减
max_amount:满多少费用才可以减
price：能减的优惠券金额
-------------------------------------
DC 折扣
max_amount:最高折扣金额
price：折扣数
--------------------------------------
CP 立减
price：能减的优惠券金额
 */

/**
 * 试算优惠券减免金额
 * @param data
 */
export function estimatedUseCouponFee(data = {},orderAmount = 0){
  const url = "/api/bns/calCoupon";
  return this.axios.post(url, data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .then(res=>{
      console.log("试算优惠券减免金额：",res);
      let list = res.datas || [];
      let discountTotal = 0;
      list.forEach(res=>{
        if(res.realPrice) discountTotal += parseFloat(res.realPrice);
      })
      discountTotal = Math.round(discountTotal * 100) / 100;
      let afterAmount = orderAmount - discountTotal;
      afterAmount = Math.round(afterAmount * 100) / 100;
      res.useCouponAfterData = {
        discountAmount:discountTotal,
        discountAfterAmount: afterAmount,
      };
      return res;
    })
    // .catch(res => {
      // this.$message.error("试算优惠券减免金额：" + res.message||"异常");
      // return Promise.reject(res);
    // });
}



//////////////////
// WEBPACK FOOTER
// ./common/selectCoupon/estimated.js
// module id = null
// module chunks = 